import { Component, inject, OnInit, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { DirByLangDirective } from '@/directives/dirByLang.directive';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PublicPaths } from '@/models/appRoutes';
import { AssistTablesService } from '@/services/assist.service';
@Component({
  selector: 'app-footer',
  imports: [RouterLink, TranslatePipe, DirByLangDirective, FormsModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent implements OnInit {
  COOKIE_BASIC_TAG: string = 'cookie-basic';
  COOKIE_PERFORMANCE_TAG: string = 'cookie-performance';
  COOKIE_FUNCTIONAL_TAG: string = 'cookie-functional';
  COOKIE_ANALYTICS_TAG: string = 'cookie-Analytics';
  COOKIE_MARKETING_TAG: string = 'cookie-Marketing';

  blnPerformanceCookie: boolean = false;
  blnfunctionalCookie: boolean = false;
  blnAnalyticsCookie: boolean = false;
  blnMarketingCookie: boolean = false;

  PublicPaths = PublicPaths;
  translate = inject(TranslateService);
  cookieService = inject(CookieService);
  assistService = inject(AssistTablesService);
  supportEmail = signal('');
  showBottomCookieSelect: boolean = true;
  showLeftCookieSelect: boolean = false;
  private openCookieSettingsHandler = () => this.openCookieSettings();

  check() {
    if (this.cookieService.check(this.COOKIE_BASIC_TAG)) {
      this.showBottomCookieSelect = false;
    }
    if (this.cookieService.check(this.COOKIE_PERFORMANCE_TAG)) {
      this.blnPerformanceCookie = true;
    }
    if (this.cookieService.check(this.COOKIE_FUNCTIONAL_TAG)) {
      this.blnfunctionalCookie = true;
    }
    if (this.cookieService.check(this.COOKIE_ANALYTICS_TAG)) {
      this.blnAnalyticsCookie = true;
    }
    if (this.cookieService.check(this.COOKIE_MARKETING_TAG)) {
      this.blnMarketingCookie = true;
    }
  }
  ngOnInit() {
    this.check();
    this.assistService.getPublicSupportEmail().subscribe((email) => {
      this.supportEmail.set(email);
    });
    window.addEventListener('open-cookie-settings', this.openCookieSettingsHandler);
  }

  ngOnDestroy() {
    window.removeEventListener('open-cookie-settings', this.openCookieSettingsHandler);
  }

  openCookieSettings() {
    this.check();
    this.showLeftCookieSelect = true;
    this.showBottomCookieSelect = false;
  }

  rejectAllCookies() {
    this.translate.resetLang('he');
    this.cookieService.delete(this.COOKIE_BASIC_TAG);
    this.showBottomCookieSelect = false;
  }

  rejectAllSelection() {
    this.blnPerformanceCookie = false;
    this.blnfunctionalCookie = false;
    this.blnAnalyticsCookie = false;
    this.blnMarketingCookie = false;
  }

  acceptAllCookies() {
    this.updateCookieByTag(this.COOKIE_BASIC_TAG, true);
    this.updateCookieByTag(this.COOKIE_PERFORMANCE_TAG, true);
    this.updateCookieByTag(this.COOKIE_FUNCTIONAL_TAG, true);
    this.updateCookieByTag(this.COOKIE_ANALYTICS_TAG, true);
    this.updateCookieByTag(this.COOKIE_MARKETING_TAG, true);
    this.showBottomCookieSelect = false;
  }

  acceptAllSelection() {
    this.blnPerformanceCookie = true;
    this.blnfunctionalCookie = true;
    this.blnAnalyticsCookie = true;
    this.blnMarketingCookie = true;
  }

  saveCookiesDef() {
    this.updateCookieByTag(this.COOKIE_BASIC_TAG, true);
    this.updateCookieByTag(this.COOKIE_PERFORMANCE_TAG, this.blnPerformanceCookie);
    this.updateCookieByTag(this.COOKIE_FUNCTIONAL_TAG, this.blnfunctionalCookie);
    this.updateCookieByTag(this.COOKIE_ANALYTICS_TAG, this.blnAnalyticsCookie);
    this.updateCookieByTag(this.COOKIE_MARKETING_TAG, this.blnMarketingCookie);
    this.showLeftCookieSelect = false;
    this.showBottomCookieSelect = false;
  }

  updateCookieByTag(name: string, active: boolean) {
    if (active) {
      this.cookieService.delete(name);
      this.cookieService.set(name, 'true', 365);
    } else {
      this.cookieService.delete(name);
    }
  }
}
